import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import * as Diff from 'diff';
import { useGetQuestionQuery, useUpdateQuestionMutation, useUpdateQuestionSectionLinkMutation, useUpdateTemplateTextMutation, useUpsertOptionMutation, TemplateEngineContext } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'question-content',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useUpdateQuestionMut = useUpdateQuestionMutation(),
      updateQuestion = _useUpdateQuestionMut.mutate,
      onDone = _useUpdateQuestionMut.onDone;
    var _useUpdateQuestionSec = useUpdateQuestionSectionLinkMutation(),
      updateQuestionSectionLink = _useUpdateQuestionSec.mutate,
      onUpdateLinkDone = _useUpdateQuestionSec.onDone;
    var _useUpdateTemplateTex = useUpdateTemplateTextMutation(),
      mutateTemplateText = _useUpdateTemplateTex.mutate;
    var _useUpsertOptionMutat = useUpsertOptionMutation(),
      upsertOption = _useUpsertOptionMutat.mutate;
    var templateEngineContextOptions = [{
      text: 'Fund',
      value: TemplateEngineContext.Fund
    }, {
      text: 'Impact Solution',
      value: TemplateEngineContext.ImpactSolution
    }, {
      text: 'Impact',
      value: TemplateEngineContext.Impact
    }];
    var handleTemplateTextUpdate = function handleTemplateTextUpdate(_ref) {
      var id = _ref.id,
        text = _ref.text;
      // Store the update for batch saving
      if (!templateTexts.value) {
        templateTexts.value = [];
      }
      templateTexts.value = templateTexts.value.map(function (templateText) {
        if (templateText.id === id) {
          return _objectSpread(_objectSpread({}, templateText), {}, {
            text: text
          });
        }
        return templateText;
      });
    };
    var question = ref({});
    var templateTexts = ref([{
      id: 0,
      text: ''
    }]);
    var scoringRulesExpanded = ref(false);
    var isJsonString = function isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    };
    onUpdateLinkDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    onDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    var disabledSave = ref(false);
    var toggleDisableSave = function toggleDisableSave(value) {
      disabledSave.value = value;
    };
    var save = function save() {
      var _question$value;
      var input = {
        id: props.id
      };
      for (var _i = 0, _Object$keys = Object.keys(changesByKey.value); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (['scoringRules'].includes(key)) {
          input[key] = isJsonString(question.value[key]) ? JSON.parse(question.value[key]) : question.value[key];
          // FIXME this is another place we have to do a special handling, I haven't figure out the best way yet with JSON-Editor because sometime is returns JSON sometimes STRING
        } else {
          input[key] = question.value[key];
        }
      }
      updateQuestion({
        input: input
      }).then(function () {
        window.$nuxt.$emit('userMsg');
      });

      // Check and update template texts if changed
      if ((_question$value = question.value) !== null && _question$value !== void 0 && _question$value.templateTexts) {
        templateTexts.value.forEach(function (text, index) {
          var _question$value2;
          if (text.text !== ((_question$value2 = question.value) === null || _question$value2 === void 0 ? void 0 : _question$value2.templateTexts[index].text)) {
            mutateTemplateText({
              input: {
                id: text.id,
                text: text.text
              }
            });
          }
        });
      }
    };
    var changesByKey = computed(function () {
      var obj = {};
      for (var _i2 = 0, _Object$keys2 = Object.keys(((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getQuestion) || {}); _i2 < _Object$keys2.length; _i2++) {
        var _result$value, _result$value2, _result$value2$getQue;
        var key = _Object$keys2[_i2];
        var changes = [];
        changes = Diff.diffJson(((_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : (_result$value2$getQue = _result$value2.getQuestion) === null || _result$value2$getQue === void 0 ? void 0 : _result$value2$getQue[key]) || '', question.value[key] || '').filter(function (c) {
          return c.added || c.removed;
        });
        if (changes.length) {
          obj[key] = changes;
        }
      }
      return obj;
    });
    var _useGetQuestionQuery = useGetQuestionQuery({
        id: props.id
      }, computed(function () {
        return {
          enabled: !!props.id
        };
      })),
      onResult = _useGetQuestionQuery.onResult,
      result = _useGetQuestionQuery.result,
      loading = _useGetQuestionQuery.loading,
      refetch = _useGetQuestionQuery.refetch;
    onResult(function (v) {
      var _v$data;
      if (v !== null && v !== void 0 && (_v$data = v.data) !== null && _v$data !== void 0 && _v$data.getQuestion) {
        var _v$data2, _v$data2$getQuestion;
        var items = [{
          name: v.data.getQuestion.label,
          id: 0
        }].concat(_toConsumableArray(reverseHierarchy(v.data.getQuestion.questionSectionLinks || [])));
        question.value = _objectSpread(_objectSpread({}, v.data.getQuestion), {}, {
          reversedHierarchy: items
        });
        templateTexts.value = ((_v$data2 = v.data) === null || _v$data2 === void 0 ? void 0 : (_v$data2$getQuestion = _v$data2.getQuestion) === null || _v$data2$getQuestion === void 0 ? void 0 : _v$data2$getQuestion.templateTexts) || [];
      }
    });
    var reverseHierarchy = function reverseHierarchy(data) {
      return (data === null || data === void 0 ? void 0 : data.map(function (item) {
        var current = item.section;
        var lastNode = null;

        // Construct the hierarchy from the top-most node down to the original node
        while (current) {
          // Create a new node for the current section, starting without children
          var newNode = {
            id: current.id,
            name: current.label,
            children: []
          };

          // If lastNode exists, it's a child of the new node
          if (lastNode) {
            newNode.children.push(lastNode);
          }

          // Move 'newNode' up in the hierarchy
          lastNode = newNode;

          // Move to the next parent in the original data
          current = current.parent;
        }
        return lastNode;
      })) || [];
    };
    var notCustomizable = computed(function () {
      return active.value[0] !== 0;
    });
    var active = ref([0]);
    var allSectionIds = function allSectionIds(link) {
      var ids = [];
      var current = link;
      while (current) {
        ids.push(current.id);
        current = current.parent;
      }
      return ids;
    };
    var isSectionInActive = function isSectionInActive(sectionQuestion, active) {
      var ids = sectionQuestion && sectionQuestion.section ? allSectionIds(sectionQuestion.section) : [];
      var firstActive = active && active[0];
      return Array.isArray(ids) && typeof firstActive !== 'undefined' && ids.map(String).includes(String(firstActive));
    };
    return {
      __sfc: true,
      updateQuestion: updateQuestion,
      onDone: onDone,
      updateQuestionSectionLink: updateQuestionSectionLink,
      onUpdateLinkDone: onUpdateLinkDone,
      mutateTemplateText: mutateTemplateText,
      upsertOption: upsertOption,
      templateEngineContextOptions: templateEngineContextOptions,
      handleTemplateTextUpdate: handleTemplateTextUpdate,
      question: question,
      templateTexts: templateTexts,
      scoringRulesExpanded: scoringRulesExpanded,
      isJsonString: isJsonString,
      props: props,
      disabledSave: disabledSave,
      toggleDisableSave: toggleDisableSave,
      save: save,
      changesByKey: changesByKey,
      onResult: onResult,
      result: result,
      loading: loading,
      refetch: refetch,
      reverseHierarchy: reverseHierarchy,
      notCustomizable: notCustomizable,
      active: active,
      allSectionIds: allSectionIds,
      isSectionInActive: isSectionInActive
    };
  }
});